/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DeptDeleteController',DeptDeleteController);

    DeptDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dept'];

    function DeptDeleteController($uibModalInstance, entity, Dept) {
        var vm = this;

        vm.dept = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dept.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
